import { parseCurrencyType, type CurrencyType } from '@/features/hierarchy/hierarchy'

/**
 * Lab Net Expo money display — INR majors (`Rs.`), including for POINTS.
 *
 * Used by: NE **list** grid + Betfair **Line Session** workstation book.
 * Lab book calc is INR (`stake × rate`); do **not** ÷100 to Pts.
 *
 * - POINTS / POINT@1: show INR majors as-is (`alreadyDisplay`)
 * - INR: unchanged
 */
export function lineSessionMoneyOpts(rawCurrency: string | undefined | null): {
  currency: CurrencyType
  alreadyDisplay: boolean
} {
  const raw = String(rawCurrency ?? 'INR')
    .trim()
    .toUpperCase()
  if (
    raw === 'POINTS' ||
    raw === 'POINT' ||
    raw === 'POINT@1' ||
    raw === 'POINT1' ||
    raw === 'POINT_AT_1'
  ) {
    return { currency: 'INR', alreadyDisplay: true }
  }
  return { currency: parseCurrencyType(raw), alreadyDisplay: false }
}
